// extracted by mini-css-extract-plugin
export var container = "our-approach-key-figure-v2-module--container--3ab9a";
export var description = "our-approach-key-figure-v2-module--description--cc33d";
export var hidden = "our-approach-key-figure-v2-module--hidden--178e3";
export var value = "our-approach-key-figure-v2-module--value--84175";
export var valueOnly = "our-approach-key-figure-v2-module--valueOnly--38a0b";